// apps/account-portal/src/pages/HelpPage.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import PageContainer from '../components/PageContainer';
import PageTitle from '../components/PageTitle';
import Card from '../components/Card';

const HelpPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContainer>
      <PageTitle title={t('pages.help.title')} />

      <div className="space-y-6">
        {/* 快速開始 */}
        <Card>
          <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">
            {t('pages.help.getting_started.title')}
          </h2>
          <div className="space-y-3 text-[var(--text-secondary)]">
            <p>{t('pages.help.getting_started.description')}</p>
            <ol className="list-decimal list-inside space-y-2 ml-4">
              <li>{t('pages.help.getting_started.step1')}</li>
              <li>{t('pages.help.getting_started.step2')}</li>
              <li>{t('pages.help.getting_started.step3')}</li>
            </ol>
          </div>
        </Card>

        {/* 訂閱管理 */}
        <Card>
          <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">
            {t('pages.help.subscription_management.title')}
          </h2>
          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-medium text-[var(--text-primary)] mb-2">
                {t('pages.help.subscription_management.view_subscription')}
              </h3>
              <p className="text-[var(--text-secondary)]">
                {t('pages.help.subscription_management.view_description')}
              </p>
            </div>
            <div>
              <h3 className="text-lg font-medium text-[var(--text-primary)] mb-2">
                {t('pages.help.subscription_management.change_plan')}
              </h3>
              <p className="text-[var(--text-secondary)]">
                {t('pages.help.subscription_management.change_description')}
              </p>
            </div>
            <div>
              <h3 className="text-lg font-medium text-[var(--text-primary)] mb-2">
                {t('pages.help.subscription_management.cancel_subscription')}
              </h3>
              <p className="text-[var(--text-secondary)]">
                {t('pages.help.subscription_management.cancel_description')}
              </p>
            </div>
          </div>
        </Card>

        {/* 帳單與付款 */}
        <Card>
          <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">
            {t('pages.help.billing.title')}
          </h2>
          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-medium text-[var(--text-primary)] mb-2">
                {t('pages.help.billing.view_history')}
              </h3>
              <p className="text-[var(--text-secondary)]">
                {t('pages.help.billing.history_description')}
              </p>
            </div>
            <div>
              <h3 className="text-lg font-medium text-[var(--text-primary)] mb-2">
                {t('pages.help.billing.payment_methods')}
              </h3>
              <p className="text-[var(--text-secondary)]">
                {t('pages.help.billing.payment_description')}
              </p>
            </div>
          </div>
        </Card>

        {/* 常見問題 */}
        <Card>
          <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">
            {t('pages.help.faq.title')}
          </h2>
          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-medium text-[var(--text-primary)] mb-2">
                {t('pages.help.faq.q1')}
              </h3>
              <p className="text-[var(--text-secondary)]">
                {t('pages.help.faq.a1')}
              </p>
            </div>
            <div>
              <h3 className="text-lg font-medium text-[var(--text-primary)] mb-2">
                {t('pages.help.faq.q2')}
              </h3>
              <p className="text-[var(--text-secondary)]">
                {t('pages.help.faq.a2')}
              </p>
            </div>
            <div>
              <h3 className="text-lg font-medium text-[var(--text-primary)] mb-2">
                {t('pages.help.faq.q3')}
              </h3>
              <p className="text-[var(--text-secondary)]">
                {t('pages.help.faq.a3')}
              </p>
            </div>
          </div>
        </Card>

        {/* 聯絡支援 */}
        <Card>
          <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">
            {t('pages.help.support.title')}
          </h2>
          <div className="text-[var(--text-secondary)] space-y-4">
            <p>{t('pages.help.support.description')}</p>
            <div className="flex justify-start">
              <a
                href="https://line.me/ti/p/~neilshih"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-brand-600 hover:bg-brand-700 text-white font-bold py-3 px-6 rounded transition-all duration-200 text-center inline-block"
              >
                {t('pages.help.support.contact_us')}
              </a>
            </div>
          </div>
        </Card>
      </div>
    </PageContainer>
  );
};

export default HelpPage;
